module.exports = __webpack_public_path__ + "media/components/V2/Common/Logo/logo-b67934c6e150aef69075776702a6a74c.png";